import React from 'react';
import { withTranslation } from 'react-i18next';

// Create a custom error boundary component for Keycloak errors
class KeycloakErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Keycloak error caught:", error, errorInfo);
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-xl font-bold text-red-600 mb-4">{t('keycloakError.title')}</h2>
            <p className="text-gray-700 mb-4">
              {t('keycloakError.message')}
            </p>
            <p className="text-sm text-gray-500 mb-4">
              {t('keycloakError.errorLabel')}: {this.state.error?.message || t('keycloakError.unknownError')}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded"
            >
              {t('keycloakError.refresh')}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(KeycloakErrorBoundary);
